import React,{Component} from 'react';
import { browserHistory } from 'react-router';
import WebFooter from './WebFooter.js';
import { Breadcrumb  } from 'react-bootstrap';
import WebHeaderInner from './WebHeaderInner.js';
import $ from 'jquery';


export default class Web_CustomerCare_Seller extends Component {
	constructor(props){
    super(props);
    this.state={
      email:'',
      mobiles:'',
      timings:'',
    };
    this.getDeviceId=this.getDeviceId.bind(this);
  }
  componentDidMount(){
    if(screen.width < 800){
      window.location.href="/customer_care_seller";
    }
    this.getDeviceId();
    var baseUrl='https://aquadeals.in/admin/web3/user/';
    var data1={from: 'desktop_web',user_id:localStorage.user_id};
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'getSellerSupportDetails',
          dataType:'json',
          data: {req:data2},
          success: function(data){
              this.setState({
                  email:data.email,
                  timings: data.timings,
                  mobiles: data.phone,
                  username:data.username,                  
              });
          }.bind(this),
          error: function(err){
            
          }
    });
  }
  getDeviceId(){
    if(localStorage.user_id){
        var user_id=localStorage.user_id;
    }
    else{
      user_id=0;
    }
    var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
    var data2=JSON.stringify(data1);
    var baseUrl='https://aquadeals.in/admin/web3/user/';
    $.ajax({
        method: 'POST',
        url: baseUrl+'getDeviceId',
        dataType: 'json',
        data:{req: data2},
        success: function(data){
          
        },
        error: function(err){
        }
    });
  }

render(){
  document.title ="AquaDeals Customer Care";
  document.getElementsByTagName("META")[2].content="AquaDeals Customer Care";
      return (
      <div className="lgt_gry web_deals web_customer_care_page">
          <WebHeaderInner />
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          
          <section className="container">
              <div className="row">
                 <div className="col-md-6 col-md-offset-3">
                 <div className="dels_cntnt web_customer_care">
                        <div className="del_rgt_blk">
                            
                          <div className="clr"></div>
                              <div className="del_dtl">
                                    <div className="pag_cntnt customer_care">
                                        <div className="mod_cc_bg">
                                          <div>
                                                <div className="clr">&nbsp;</div>
                                                <div className="clr">&nbsp;</div>
                                                <div className="clr">&nbsp;</div>                                            
                                                <div className="clr">&nbsp;</div>                                            
                                                <div className="clr">&nbsp;</div>                                            
                                                <div className="clr">&nbsp;</div>                                            
                                          </div>
                                        </div>
                                          <div className="mob_cc_image">
                                            <img src={require('./../../../assets/images/icon_cust_sup.png')} alt="..."></img>
                                          </div>                                                    
                                        <div className="container-fluid">
                                          <div className="col-md-12">
                                          <section id="cc_content_block">
                                            <h3>Dear <span>{this.state.username}</span> ,</h3>
                                            <p id="cc_cnt">If you have any questions or concerns about our products or services, feel free to contact our Customer Support team.</p>
                                          </section>
                                          <section id="cc_contact_list">
                                            <a href={"mailto:"+this.state.email}><p><span><img  src={require('./../../../assets/images/mail_icn.png')} /></span><span>{this.state.email}</span></p></a>
                                            <p><span><img  src={require('./../../../assets/images/phone_icn.png')} /></span>{this.state.mobiles}</p>
                                            <p><span><img  src={require('./../../../assets/images/timer_icn.png')} /></span>{this.state.timings}</p>
                                          </section>
                                          <section id="cc_wb_div">
                                            {/*<button className="cc_wb_btn" onClick={()=>{this.chatnow()}}><span id="cnt_wb_icon"><img  src={require('./../../../assets/images/wa_app.png')} width="20" /></span><span>CHAT NOW</span></button> */}
                                          </section>
                                            </div>
                                        </div>
                                      </div>
                              </div>
                        </div>
              </div>
          </div>
          </div>

          <div className="clr"></div> 
          </section>

        <div className="cust_car_ftr">
          <WebFooter /> 
        </div>
        
      </div>
  );
    }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_customer_care_seller.js
 **/